<template>
  <section class="panel pad">
    <div class="panel-head">
      <h2>报价咨询</h2>
      <button type="button" class="btn ghost sm" @click="load">刷新</button>
    </div>
    <p v-if="error" class="error">{{ error }}</p>
    <p v-else-if="!rows.length" class="muted">还没有咨询。</p>
    <div v-for="item in rows" :key="item.id" class="list-item">
      <div>
        <strong>{{ kindLabel(item.kind) }}</strong>
        <span class="muted"> · {{ item.phone }}</span>
        <span v-if="item.email" class="muted"> · {{ item.email }}</span>
        <span class="muted"> · {{ formatTime(item.created_at) }}</span>
        <p>{{ item.summary }}</p>
        <p v-if="detailText(item)" class="muted">{{ detailText(item) }}</p>
      </div>
      <div>
        <button
          type="button"
          class="btn ghost sm"
          @click="mark(item, item.status === 'contacted' ? 'new' : 'contacted')"
        >{{ item.status === 'contacted' ? '标为未联系' : '标为已联系' }}</button>
      </div>
    </div>
  </section>
</template>

<script>
import { adminListInquiries, adminInquiryStatus } from '../../api/platformService'

export default {
  name: 'AdminInquiries',
  data() {
    return {
      rows: [],
      error: ''
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    kindLabel(kind) {
      return kind === 'bom' ? '服务器估价' : '选型'
    },
    formatTime(iso) {
      if (!iso) return ''
      return iso.replace('T', ' ').slice(0, 16)
    },
    detailText(item) {
      let data = item.detail
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data)
        } catch (e) {
          return ''
        }
      }
      if (!data || typeof data !== 'object') return ''
      const parts = []
      if (data.text) parts.push(data.text)
      if (data.primary) parts.push(`首选 ${data.primary}`)
      if (data.template_name) parts.push(data.template_name)
      if (data.total) parts.push(`${data.total} ${data.currency || ''}`.trim())
      return parts.join(' · ')
    },
    async load() {
      this.error = ''
      try {
        this.rows = await adminListInquiries()
      } catch (err) {
        this.error = err.response?.data?.error || '加载失败'
        this.rows = []
      }
    },
    async mark(item, status) {
      await adminInquiryStatus(item.id, status)
      item.status = status
    }
  }
}
</script>
